module.exports = __webpack_public_path__ + "img/fopeaVacaMuerta3.2d25edfe.jpg";